export const TASK_LOG_MARKERS = {
    OCTOCOPY: "##OCTOCOPY##",
    OCTOLINE: "##OCTOLINE##",
    OCTOCATEGORY: "##OCTOCATEGORY##",
} as const;
export const CATEGORY_PADDING_WIDTH = 12;
